import { Component } from '@angular/core';
// import config.js
import config from '../../../../../config';
import {
  COMMON_IMPORTS,
  PIPES_IMPORTS,
} from '../../../../shared/imports/common-imports';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [PIPES_IMPORTS, COMMON_IMPORTS],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  applicationName = config.application_name;
  applicationVersion = config.application_version;
  copyrightYear = new Date().getFullYear();
}
